
import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LocalStorageService } from './services/local-storage.service';
import { AppState } from './app.state';
import { constants } from './shared/constants';

@Injectable({
  providedIn: 'root',
})
export class AppService {


  constructor(
    private activatedRoute: ActivatedRoute,
    public localStorageService: LocalStorageService,
    public appState: AppState,
  ) {
    this.initSubscription();
  }

  initSubscription() {

    this.activatedRoute.queryParams.subscribe((res) => {
      if (Object.keys(res).length != 0) {
        res = Object.keys(res)
          .filter((key) => key !== 'idToken' && key !== 'accessToken')
          .reduce((obj, key) => {
            obj[key] = res[key];
            return obj;
          }, {});

        let setAppQueryParams;
        let getAppQueryParams;
        if (this.localStorageService.get('appQueryParams')) {
          getAppQueryParams = JSON.parse(this.localStorageService.get('appQueryParams'));
        }
        if (getAppQueryParams && Object.keys(getAppQueryParams).length) {
          setAppQueryParams = { ...getAppQueryParams, ...res };
        } else {
          setAppQueryParams = res;
        }
        this.localStorageService.set('appQueryParams', JSON.stringify(setAppQueryParams));
      }
    });

    this.appState.companyInfo$.subscribe((res) => {
      if (res && res?.sellSideConfig && res?.sellSideConfig?.sellerAppTheme) {
        let sellerAppTheme = res?.sellSideConfig?.sellerAppTheme;
        this.setPageContentFromBaseUrl();
        sellerAppTheme.primaryColor &&
          document.documentElement.style.setProperty('--primaryColor', sellerAppTheme.primaryColor);

        sellerAppTheme.primaryFontFamily &&
          document.documentElement.style.setProperty('--primaryFontFamily', sellerAppTheme.primaryFontFamily);
        sellerAppTheme.secondaryFontFamily &&
          document.documentElement.style.setProperty('--secondaryFontFamily', sellerAppTheme.secondaryFontFamily);

        sellerAppTheme.primaryHoverColor &&
          document.documentElement.style.setProperty('--primaryHoverColor', sellerAppTheme.primaryHoverColor);
        sellerAppTheme.primaryBGColor &&
          document.documentElement.style.setProperty('--primaryBGColor', sellerAppTheme.primaryBGColor);
        sellerAppTheme.primaryButtonColor &&
          document.documentElement.style.setProperty('--primaryButtonColor', sellerAppTheme.primaryButtonColor);
        sellerAppTheme.primaryTitleColor &&
          document.documentElement.style.setProperty('--primaryTitleColor', sellerAppTheme.primaryTitleColor);
        sellerAppTheme.primaryTextColor &&
          document.documentElement.style.setProperty('--primaryTextColor', sellerAppTheme.primaryTextColor);
        sellerAppTheme.primaryTextLight &&
          document.documentElement.style.setProperty('--primaryTextLight', sellerAppTheme.primaryTextLight);
        sellerAppTheme.secondaryTextColor &&
          document.documentElement.style.setProperty('--secondaryTextColor', sellerAppTheme.secondaryTextColor);
        sellerAppTheme.bgColor042a32 &&
          document.documentElement.style.setProperty('--bgColor042a32', sellerAppTheme.bgColor042a32);
        sellerAppTheme.secondaryColor &&
          document.documentElement.style.setProperty('--secondaryColor', sellerAppTheme.secondaryColor);
        sellerAppTheme.primaryBorderColor &&
          document.documentElement.style.setProperty('--primaryBorderColor', sellerAppTheme.primaryBorderColor);
        sellerAppTheme.primaryErrorColor &&
          document.documentElement.style.setProperty('--primaryErrorColor', sellerAppTheme.primaryErrorColor);
      }
    });
  }

  setPageContentFromBaseUrl() {
    const title: any = document.querySelector(`#title`);
    const link: any = document.querySelector(`link[rel*='icon']`);
    link.href = this.appState.companyInfoValue.favIcon || constants.COMPANY.prospektr.favicon;
    title.textContent = this.appState.companyInfoValue.name || constants.COMPANY.prospektr.name;
  }
}